import { render, staticRenderFns } from "./SkeuomorphismDecor.vue?vue&type=template&id=e4a42024&"
import script from "./SkeuomorphismDecor.vue?vue&type=script&lang=ts&"
export * from "./SkeuomorphismDecor.vue?vue&type=script&lang=ts&"
import style0 from "./SkeuomorphismDecor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports